import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import CustomTable from "../../components/custom-table/CustomTable";
import { projectManagerListingData } from "../../utils/tableData";
import {  useSelector } from "react-redux";
import PIProjectManagerApi from "../../services/coordinatingPiProjectManagerService";
import PISubjectApi from "../../services/coordinatingPiSubject";
import ShowAssignedPIPMDrawer from "../../components/custom-drawer/showAssignedPIPMdrawer";
import CustomModel from "../../components/custom-model/CustomModel";
import { updatePhaseValues } from "../../utils/formik/initialValues";
import { updatPhaseValidationSchema } from "../../utils/formik/validationSchema";
import { notify } from "../../bmr/utils/methods/notification";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav";
import CustomSearchbar from "../../components/custom-searchbar/CustomSearchbar";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import NoDataCard from "../../components/no-data-card";
import { Typography } from "@mui/material";


const convertPIProjectManagerData = (data) => {
    return data?.map(projectManager => {
        let transformedName = projectManager?.name
        let transformedPhone = projectManager?.phone
        let transformedPhase = projectManager?.phaseCount

        let transformedEmail = projectManager?.email
        let phaseList = projectManager?.phaseDetails
        let transformedPI = projectManager?.id
        return [transformedName, transformedPhone, transformedPhase, transformedEmail, phaseList, transformedPI];
    });
}

export const ProjectManagerPage = () => {
    const { loginId, role_slug } = useSelector((state) => state.loginData);
    const isInvestigator = role_slug === 'investigator';
    const [isEditor] = useState(role_slug === 'editor');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [submitLoading, setSubmitLoading] = useState(false);
    const [tableFilters, setTablesFilters] = useState({ searchData: '' })
    const [currentPage, setCurrentpage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [piData, setPiData] = useState(projectManagerListingData);
    const [phaseID, setPhaseID] = useState(null)
    const [phaseList, setPhaseList] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [phaseListData, setPhaseListData] = useState([])
    const [initialValues, setInitialValues] = useState(updatePhaseValues);
    const [openModal, setOpenModal] = React.useState(false);
    const [projectManagerResponse, setProjectManagerResponse] = useState([])
    const [rowId, setRowId] = useState(null)
    const [modelData, setModelData] = useState({
        editTitle: "Update Phase",
        children: [
            {
                type: "multidropdown",
                name: "phase",
                label: "Phase ",
                placeholder: "Select Phase",
                data: phaseList,
                IsRequired: true,
            }
        ],
    });
    const [phaseSearch, setPhaseSearch] = useState("");
    const handleNavigateToDetails = React.useCallback((row) => {
        navigate(`assigned-patient-navigators-details/${row[row?.length - 1]}`, {
          state: [
            { name: "Assigned Patient Navigators", path: location.pathname },
            {
              name: "Details",
              path: `${location.pathname}/assigned-patient-navigators-details/${row[row?.length - 1]}`,
            },
          ],
        });
    }, []);

    useEffect(() => {
        if (tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " ") {
            setLoading(true)
            getPiProjectManagerListing();
        }
    }, [currentPage, tableFilters, phaseID])

    useEffect(() => {
        getPhase()
    }, [])

    // Updated phase dropdown function to match Subject page

const getPhase = () => {
  let investigator_id = "";
  let user_id = "";
  let editor_id = "";

  if (isInvestigator) {
    investigator_id = loginId;
  } 
  else if (isEditor) {
    editor_id = loginId;
  } 
  else {
    user_id = loginId;
  }

  PISubjectApi.getPhaseDropDown("", investigator_id, user_id, editor_id)
    .then((res) => {
      const data = res?.data?.map((val) => ({
        id: val.id,
        name: `${val.title} (${val?.product_details?.name})`,
      }));
      setPhaseList(data);
    })
    .catch((error) => {
      notify.error(error);
    });
};

    const getPiProjectManagerListing = () => {
        const investigatorId = loginId;
        
        PIProjectManagerApi.getPIProjectManagerData(10, currentPage, tableFilters?.searchData, phaseID, investigatorId)
            .then((res) => {
                let rowData = convertPIProjectManagerData(res?.data || [])
                setProjectManagerResponse(res?.data)
                setPiData(prev => ({
                    ...prev,
                    rows: [...rowData]
                }));

                setTotalPage(Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit));
                setCurrentpage(res?.page_details?.page);
                setLoading(false);
            })
            .catch((error) => {
                notify.error(error)
                setLoading(false);
            })
    }

    const handleTableFilters = (e) => {
        setTablesFilters({ ...tableFilters, searchData: e })
        setCurrentpage(1)
    }

    const handlePagination = async (value) => {
        setCurrentpage(value);
    };

    const handleDropDownChange = (e) => {
        setPhaseID(e.target.value)
        setCurrentpage(1)
    }
    const handleCellClick = (row) => {
    setPhaseListData(row[row?.length - 2]);
    setOpenDrawer(true);
  };

    const handleAddButton = (row) => {
        setOpenModal(true)
        setRowId(row[row?.length - 1])
        const projectManagerData = projectManagerResponse.find((projectManager) => projectManager.id === (row[row?.length - 1]));
        setInitialValues({
            phase: projectManagerData?.phaseDetails.map(item => item.id),
        });
    }

  const filteredPhaseListData = phaseListData.filter(phase =>
    phase?.title?.toLowerCase().includes(phaseSearch.toLowerCase()) ||
    phase?.product_details?.name?.toLowerCase().includes(phaseSearch.toLowerCase())
  );











  return (
    <>
      <div className="flex flex-col gap-0 bg-white p-0 !pb-0">
        <CustomModel
          rowId={rowId}
          modalInitialValues={initialValues}
          initialValuesValidationSchema={updatPhaseValidationSchema}
          open={openModal}
          setOpen={setOpenModal}
          setModelData={setModelData}
          modelData={modelData}
        />
        <CustomTable
          rows={piData?.rows}
          columnAlign={piData?.columnAlign}
          columns={piData?.columns}
          TableData={piData?.TableData}
          handleNavigate={handleNavigateToDetails}
          loading={loading}
          handleTableFilters={handleTableFilters}
          handleChangePage={handlePagination}
          handleAddButton={handleAddButton}
          handleChangeDropDown={handleDropDownChange}
          dropDownValue={phaseID}
          MenuList={phaseList}
          tableFilters={tableFilters}
          currentPage={currentPage}
          totalpage={totalPage}
          isCloumnClick={true}
          handleCellClick={handleCellClick}
        />
      </div>

      {/* Phase List Drawer */}
      <ShowAssignedPIPMDrawer 
        open={openDrawer} 
        toggleDrawer={() => setOpenDrawer(false)}
      >
        <div className="w-[25rem]">
          <div className="pl-4 pt-4 pr-4">
            <HeaderBackNav
              handleBackNav={() => setOpenDrawer(false)}
              TitleFontSize={"18px"}
              TitleFontWeight={700}
              Title="Phase List"
            />
          </div>
          <hr />
          <div className="pl-3 pt-3 pr-3">
            <CustomSearchbar
              Placeholder="Search by Phase or Product"
              BgColor="#dfe0eb"
              value={phaseSearch}
              handleSearch={(value) => setPhaseSearch(value)}
            />
            <ul className="p-2 cursor-pointer">
              {loading ? (
                <SkeletonLoader rowCount={5} height={"35px"} />
              ) : filteredPhaseListData?.length === 0 ? (
                <div className="mt-4">
                  <NoDataCard />
                </div>
              ) : (
                filteredPhaseListData?.map((phase, index) => (
                  <li
                    key={phase?.id || index}
                    className="flex gap-3 align-center pt-2 pb-2"
                    style={{ borderBottom: "2px solid #dfe0eb" }}
                  >
                    
                    <div className="self-center">
                      <Typography variant="h6">
                        {phase?.title || "Phase title not available"}
                      </Typography>
                      {phase?.product_details?.name && (
                        <Typography variant="body2" color="textSecondary">
                          Product: {phase.product_details.name}
                        </Typography>
                      )}
                    </div>
                  </li>
                ))
              )}
            </ul>
          </div>
        </div>
      </ShowAssignedPIPMDrawer>
    </>
  );
};